import { AdditionalUserSettings, FieldValidations, IFieldValidator, User } from "@samc/auth-authorization";

export class UserFieldValidator implements IFieldValidator<User> {
  readonly maxLength: number = 20;
  fieldName: string;
  constructor(fieldName: string) {
    this.fieldName = fieldName;
  }

  public isValid(value: User, userDataFields: AdditionalUserSettings): FieldValidations<User> {
    const validations: FieldValidations<User> = {};
    const field = userDataFields.fields.filter(f => f.fieldName == this.fieldName)[0];

    const userDataObj: any = value.userData !== "" ? JSON.parse(value.userData) as {} : {};

    if (userDataObj[this.fieldName] !== undefined) {
      const value: string = userDataObj[this.fieldName];

      if (/[^0-9a-zA-Z]/.test(value) || value.length > this.maxLength) {
        validations.userData = field.label + " must be Alphanumeric upto " + this.maxLength +" characters.";
      }
    }

    return validations;
  }
}